"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfOutlinePropertiesHelper = void 0;
var color_1 = require("../../../../../core/model/color/color");
var unit_converter_1 = require("@devexpress/utils/lib/class/unit-converter");
var rtf_drawing_keywords_1 = require("../../../../translation-table/rtf-drawing-keywords");
var RtfOutlinePropertiesHelper = (function () {
    function RtfOutlinePropertiesHelper(shapePropertiesInfo) {
        this.shapePropertiesInfo = shapePropertiesInfo;
    }
    RtfOutlinePropertiesHelper.prototype.applyProperties = function (shape) {
        var fLine = this.shapePropertiesInfo.getPropertyOrNull(rtf_drawing_keywords_1.RtfDrawingKeywords.Line);
        if (!fLine)
            return;
        this.processOutlineWidth(shape);
        this.processOutlineFill(shape);
    };
    RtfOutlinePropertiesHelper.prototype.processOutlineWidth = function (shape) {
        shape.outlineWidth = unit_converter_1.UnitConverter.emuToTwips(this.shapePropertiesInfo.getProperty(rtf_drawing_keywords_1.RtfDrawingKeywords.LineWidth, 9525));
    };
    RtfOutlinePropertiesHelper.prototype.processOutlineFill = function (shape) {
        var outlineColor = this.shapePropertiesInfo.getNullableColorProperty(rtf_drawing_keywords_1.RtfDrawingKeywords.LineColor);
        if (outlineColor)
            shape.outlineColor = outlineColor;
        else
            shape.outlineColor = color_1.ColorHelper.BLACK_COLOR;
    };
    return RtfOutlinePropertiesHelper;
}());
exports.RtfOutlinePropertiesHelper = RtfOutlinePropertiesHelper;
